export default __webpack_public_path__ + "static/media/YouTube_Logo_2017.1af8e2c8.svg";